import React, { memo, useEffect, useMemo } from "react";
import { Icon } from "@smartsuite/react-ui/lib/components/utils/Icon/Icon";
import { text } from "../../attachment.text";
export const EditorAttachment = memo(function EditorAttachment({ attrs, service, onUpload, }) {
    var _a, _b, _c;
    const href = useMemo(() => service.getAttachmentUrl(attrs), [attrs, service]);
    useEffect(() => {
        if (!attrs.url) {
            return;
        }
        onUpload(attrs.url);
    }, [attrs.url, onUpload]);
    return (React.createElement("a", { className: "attachment-link", href: href || attrs.url, target: "_blank", rel: "noreferrer" },
        React.createElement(Icon, { name: "attachment", color: "currentColor", size: "S", className: "attachment-link__icon" }), (_c = (_b = (_a = attrs.file) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.filename) !== null && _c !== void 0 ? _c : text.uploading));
});
